import { Base64 } from "js-base64";
import React, { Fragment, useState } from "react";
import styled from "styled-components";
import { ContainerNew, SubMenu } from "../Layout";

import { _O } from "../../modules/utils";
import { setCookie } from "../../modules/utils/cookie";
import { setCookieWs } from "./../../modules/utils/cookie";

import appleLogo from "../../resources/images/icon/login/apple_logo.png";
import kakaoLogo from "../../resources/images/icon/login/kakao_logo.png";
import naverLogo from "../../resources/images/icon/login/naver_logo.png";
import useTitle from "../../modules/hooks/useTitle";

export default props => {
  useTitle("로그인_아이디찾기");
  const [dataList, setDataList] = useState(
    JSON.parse(Base64.decode(props.match.params.data))
  );
  const [selectData, setSelectData] = useState();

  const bottomFind = (
    <div
      className="under-fix-btnarea"
      style={{ textAlign: "center", margin: "0px 15px", width: "auto" }}>
      <BtnNext
        innerWidth={window.innerWidth}
        onClick={() => {
          handleFindID();
        }}>
        확인
      </BtnNext>
    </div>
  );

  const handleFindID = () => {
    if (selectData.signUpChannel === "000") {
      // _O.Open("/membership/loginAccount/" + selectData.userId);
      _O.Open("/membership/loginAccount/" + selectData.userId);
    } else {
      if (selectData.signUpChannel === "100") {
        goSnsLogin("NAVER");
      }
      if (selectData.signUpChannel === "400") {
        goSnsLogin("KAKAO");
      }
      if (selectData.signUpChannel === "500") {
        // _O.Open("/membership/login");
        _O.Open("/membership/loginAccount/" + selectData.userId);
      }
      if (selectData.signUpChannel === "600") {
        goSnsLogin("APPLE");
      }
    }
  };

  return (
    <Fragment>
      <ContainerNew
        Title={"본인인증"}
        dark={"dark"}
        leftMenu={SubMenu}
        rightMenu={-1}
        bottom={bottomFind}
        isMain={true}>
        <Contents>
          <SubTitleFind />

          {/* input area */}
          {dataList &&
            dataList.length > 0 &&
            dataList.map((m, i) => (
              <ItemComponents
                key={"dataList" + i}
                data={m}
                i={i}
                setSelectData={setSelectData}
              />
            ))}

          {/* <FindPw selectData={selectData} /> */}
        </Contents>
      </ContainerNew>
    </Fragment>
  );
};

const TextDiv = styled.div`
  text-align: left;
  font: normal normal normal 16px/20px Pretendard;
  letter-spacing: 0.53px;
  color: #000000;
  opacity: 1;
  font-weight: 500;
`;

const FindPw = props => {
  const { selectData } = props;
  const findPwEvent = selectData => {
    // 빈 값 체크
    if (selectData) {
      //Base64.encode(JSON.stringify(selectData));
      // 비밀번호 찾기 페이지로 이동
      // _O.Open("/membership/inputUserInfo/findPw/" + selectData.userId);
      _O.Open("/membership/inputUserInfo/findPw/");
    } else {
      alert("계정을 선택하세요");
    }
  };

  return (
    <TextDivPw onClick={() => findPwEvent(selectData)}>비밀번호 찾기</TextDivPw>
  );
};

const TextDivPw = styled.div`
  text-align: left;
  font: normal normal normal 14px/20px Pretendard;
  letter-spacing: 0.25px;
  color: #000000de;
  opacity: 1;
  font-weight: 500;
  // padding-left: 4px;
  // padding-bottom: 60px;
`;

const Contents = ({ children }) => {
  return (
    <div className="contents">
      <div className="sub-contents">{children}</div>
    </div>
  );
};

const BtnNext = styled.div`
  bottom: 86px;
  width: ${props => window.innerWidth - 30}px;
  height: 50px;
  line-height: 50px;
  background: #000000 0% 0% no-repeat padding-box;
  color: #fff;
  border-radius: 4px;
  opacity: 1;
  font-size: 17px;
`;

const SubTitle = styled.div`
  font-size: 24px;
  font-weight: 700;
  margin-top: 37px;
`;

const SubTitleFind = () => {
  return (
    <Fragment>
      <SubTitle>아이디 찾기</SubTitle>
      <div style={{ padding: "8px 4px" }}>
        <SubTitleText>가입 정보를 확인하세요</SubTitleText>
        <SubTitleText>선택된 계정으로 로그인합니다.</SubTitleText>
      </div>
    </Fragment>
  );
};

const SubTitleText = styled.div`
  text-align: left;
  font: normal normal normal 14px/20px Pretendard;
  letter-spacing: 0.25px;
  color: #000000de;
  opacity: 1;
  font-weight: 500;
`;

const ItemComponents = props => {
  const { data, setSelectData } = props;

  const onClickEvent = (e, data) => {
    setSelectData(data);
    $("div[name=dataItems]").css("borderColor", "#B8B8B8");
    $("div[name=dataCheck]").css("backgroundColor", "#B8B8B8");
    $("div[name=dataCheckOut]").css("border", "2px solid #B8B8B8");
    $("#dataItems" + props.i).css("borderColor", "#6200EE");
    $("#dataCheck" + props.i).css("backgroundColor", "#6200EE");
    $("#dataCheckOut" + props.i).css("border", "2px solid #6200EE");
  };

  return (
    <div
      style={{
        border: "1px solid #B8B8B8",
        padding: "19px 24px",
        borderRadius: "4px",
        marginBottom: "20px",
      }}
      // onClick={(e) => onClickEvent(e, data)}
      name="dataItems"
      id={"dataItems" + props.i}>
      <div style={{ display: "flex" }}>
        <div>
          {/* data.signUpChannel */}
          {data.signUpChannel == "100" && <NAVER />}
          {data.signUpChannel == "400" && <KAKAO />}
          {data.signUpChannel == "600" && <APPLE />}
          {(data.signUpChannel == "000" ||
            data.signUpChannel == "500" ||
            data.signUpChannel == "100") && (
            <TextDiv>아이디: {data.userId}</TextDiv>
          )}
          <TextDiv>최근사용일: {data.recentDate}</TextDiv>
          {(data.signUpChannel == "000" || data.signUpChannel == "500") && (
            <FindPw selectData={data} />
          )}
        </div>

        <div
          style={{ marginLeft: "auto", margin: "auto 8px auto auto" }}
          onClick={e => onClickEvent(e, data)}>
          <CheckBoxDivOut id={"dataCheckOut" + props.i} name={"dataCheckOut"}>
            <CheckBoxDiv id={"dataCheck" + props.i} name={"dataCheck"} />
          </CheckBoxDivOut>
        </div>
      </div>
    </div>
  );
};

const KAKAO = () => {
  return (
    <div
      style={{
        width: "100%",
        height: "30px",
        backgroundColor: "#FDDC3FFF",
        borderRadius: "30px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        font: "bold 14px/50px 고딕체",
        marginBottom: "9px",
        color: "black",
      }}>
      <img
        src={kakaoLogo}
        style={{ maxWidth: "100%", maxHeight: "19px", marginRight: "20px" }}
      />{" "}
      카카오 계정
    </div>
  );
};

const NAVER = () => {
  return (
    <div
      style={{
        width: "100%",
        height: "30px",
        backgroundColor: "#03C75AFF",
        borderRadius: "30px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        font: "bold 14px/50px 고딕체",
        marginBottom: "9px",
        color: "white",
      }}>
      <img
        src={naverLogo}
        style={{ maxWidth: "100%", maxHeight: "14px", marginRight: "20px" }} // width: "20px", height: "20px", verticalAlign: "middle", paddingRight: "17px"//, paddingLeft: "1px"//, transform:"scale(1.5)" }}
      />{" "}
      네이버 계정
    </div>
  );
};

const APPLE = () => {
  return (
    <div
      style={{
        width: "100%",
        height: "30px",
        backgroundColor: "#000000FF",
        borderRadius: "30px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        font: "bold 14px/50px 고딕체",
        marginBottom: "9px",
        color: "white",
      }}>
      <img
        src={appleLogo}
        style={{
          maxWidth: "100%",
          maxHeight: "22px",
          marginRight: "32px",
          marginLeft: "-5px",
        }}
      />{" "}
      애플 계정
    </div>
  );
};

const CheckBoxDiv = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 12px;
  // border: 1px solid #B8B8B8;
  background: #b8b8b8 0% 0% no-repeat padding-box;
  display: block;
  margin: auto;
  margin-top: 4px;
`;
const CheckBoxDivOut = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 12px;
  border: 2px solid #b8b8b8;
  background: #fff 0% 0% no-repeat padding-box;
`;

const CheckBoxDiv2 = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 12px;
  border: 1px solid #b8b8b8;
  // background: #6200EE 0% 0% no-repeat padding-box;
`;

const goSnsLogin = param => {
  // setCookie("isAutologin", isAutoLogin, 365);

  if (param === "KAKAO") {
    setCookie("signUpChannel", "400", 1);
    setCookieWs({ isAutoLogin: true, signUpChannel: "400" });
    window.location.href = "ep://login/kakao";
  }

  if (param === "NAVER") {
    setCookie("signUpChannel", "100", 1);
    setCookieWs({ isAutoLogin: true, signUpChannel: "100" });
    window.location.href = "ep://login/naver";
  }

  if (param === "APPLE") {
    setCookie("signUpChannel", "600", 1);
    setCookieWs({ isAutoLogin: true, signUpChannel: "600" });
    socketManager(SocketCommand.LOGIN_APPLE, appleLoginAf, {});
  }
};
